import type {MenuOption} from '@spaced-out/ui-design-system/lib/components/Menu';


export const SUB_DOMAIN_SUFFIX = 'sensehq.cloud';

export const AI_MESSAGE_MAX_CHAR_LENGTH = 260;

export const SENSE_CANDIDATE_LEAD = 'sense_candidate_lead';

export const CANDIDATE_LEAD = 'candidate_lead';

export const getTones = (
  t: (arg1: string, arg2: string) => string,
): string[] => [
  t('Engaging', 'Engaging'),
  t('Persuasive', 'Persuasive'),
  t('Friendly', 'Friendly'),
  t('Professional', 'Professional'),
  t('Energetic', 'Energetic'),
];

export const getLeadOptions = (
  t: (arg1: string, arg2: string) => string,
): MenuOption[] => [
  {
    key: 'Open',
    label: t('Open', 'Open'),
  },
  {
    key: 'Open - Working',
    label: t('Open_Working', 'Open - Working'),
  },
  {
    key: 'Unresponsive',
    label: t('Unresponsive', 'Unresponsive'),
  },
  {
    key: 'Unqualified',
    label: t('Unqualified', 'Unqualified'),
  },
  {
    key: 'Qualified',
    label: t('Qualified', 'Qualified'),
  },
  {
    key: 'Applied',
    label: t('Applied', 'Applied'),
  },
  {
    key: 'Converted',
    label: t('Converted', 'Converted'),
  },
  {
    key: 'Completed',
    label: t('Completed', 'Completed'),
  },
];

export const PAGE_SIZE = 10;

export const getLandingPageStatus = (
  t: (arg1: string, arg2: string) => string,
): MenuOption[] => [
  {
    key: 'published',
    label: t('Published', 'Published'),
  },
  {
    key: 'draft',
    label: t('Draft', 'Draft'),
  },
  {
    key: 'archived',
    label: t('Archived', 'Archived'),
  },
];
